var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isImage
        ? _c("el-image-viewer", {
            attrs: {
              "on-close": _vm.closeImageViewer,
              "url-list": _vm.srcList,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }